import React from "react";
import { FaLinkedinIn, FaTwitter, FaInstagram} from "react-icons/fa";
import { FiEye, FiTarget } from "react-icons/fi";

// Images (update paths if needed)
import ceoImg1 from "../assets/Aduri-Ramanjaneyulu.jpeg";
import ctaImg from "../assets/GH-Rajapur.jpg";

import { useNavigate } from "react-router-dom";


const About = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-white">

{/* ================= ABOUT COMPANY ================= */}
<section className="pt-10 pb-10 bg-white">
  <div className="max-w-6xl mx-auto px-5">

    <div className="grid lg:grid-cols-2 gap-10 items-center">

      {/* LEFT CONTENT */}
      <div className="text-center lg:text-left">

        <h2 className="text-xl md:text-2xl lg:text-[28px] font-bold tracking-tight text-primary mb-4 whitespace-nowrap">
  Chairman's Note
</h2>


        <div className="text-slate-600 text-sm leading-relaxed space-y-5 max-w-xl mx-auto lg:mx-0">
  <p>
    <span className="font-medium text-slate-700">
      Dear Valued Customers,
    </span>
  </p>

  <p>
    As the year comes to a close, we sincerely thank you for your trust and
    support in our open plotting ventures. Your confidence motivates us to
    deliver quality, transparency, and sustainable developments.
  </p>

  <p>
    This year, we launched exciting projects focused on secure investments
    and prime locations, always keeping customer satisfaction at the core.
    Choosing the right plot is an important decision, and our team remains
    committed to guiding you every step of the way.
  </p>
  <p>We look forward to creating more opportunities together and building
    vibrant communities ahead. Thank you for being part of our journey.</p>
</div>


        

        <button 
        onClick={() => navigate("/#premium-projects")}
        className="mt-8 bg-primary text-white px-7 py-3 rounded-md text-sm font-medium hover:bg-primaryDark transition">
          View Our Properties
        </button>
      </div>

      {/* RIGHT IMAGE */}
      <div className="relative flex justify-center">

        <div className="relative w-full max-w-xl">

          {/* IMAGE */}
          <img
            src={ceoImg1}
            alt="Founder & CEO"
            className="w-full h-[360px] object-cover rounded-2xl shadow-lg"
          />

          {/* INFO CARD */}
          <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 bg-white rounded-xl px-6 py-4 shadow-lg w-[300px] text-center">
            <h4 className="text-base font-semibold text-primary">
              Sri. Aduri Ramanjaneyulu
            </h4>
            <p className="text-sm text-slate-500 mb-3">
              Chairman & Managing Director 
            </p>

            {/* SOCIAL ICONS */}
            <div className="flex justify-center gap-4 text-primary text-lg">
              <a href="https://www.linkedin.com/company/aduri-group" className="hover:opacity-80 transition">
                <FaLinkedinIn />
              </a>
              <a href="https://twitter.com/adurigroup" className="hover:opacity-80 transition">
                <FaTwitter />
              </a>
              <a href="https://www.instagram.com/adurigroupofficial" className="hover:opacity-80 transition">
                <FaInstagram />
              </a>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</section>


{/* ================= VISION & MISSION ================= */}
<section className="pt-10 pb-10 bg-slate-50">
  <div className="max-w-6xl mx-auto px-6">

    {/* Section Heading */}
    <h2 className="text-3xl font-bold text-center text-primary mb-12">
      Our Vision & Mission
    </h2>

    <div className="grid md:grid-cols-2 gap-8">

      {/* OUR VISION */}
      <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition">
        
        {/* ICON + TITLE */}
        <div className="flex items-center gap-4 mb-4">
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center text-primary">
            <FiEye className="text-2xl" />
          </div>

          <h3 className="text-lg font-semibold text-primary">
            Our Vision
          </h3>
        </div>

        {/* TEXT (unchanged) */}
        <p className="text-slate-600 text-sm leading-relaxed">
          Our vision is to make land investment a low-risk, high-return opportunity for all Indians. 
          We aim to expand across multiple regions, create over 10,000 employment opportunities, and empower deserving communities. 
          Through disciplined growth and transparency, we strive to serve thousands of satisfied clients and become a leading land development organization.
        </p>
      </div>

      {/* OUR MISSION */}
      <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition">
        
        {/* ICON + TITLE */}
        <div className="flex items-center gap-4 mb-4">
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center text-primary">
            <FiTarget className="text-2xl" />
          </div>

          <h3 className="text-lg font-semibold text-primary">
            Our Mission
          </h3>
        </div>

        {/* TEXT (unchanged) */}
        <p className="text-slate-600 text-sm leading-relaxed">
          Our mission is to help customers grow their investments within a reasonable timeframe through smart land development strategies. 
          We focus on strategic locations, proper planning, and legally secure projects. 
          By offering well-planned plots at accessible price points, we make quality land ownership achievable for every investor.
        </p>
      </div>

    </div>
  </div>
</section>

 {/* ================= ABOUT COMPANY ================= */}
<section className="pt-10 pb-10 bg-white">
  <div className="max-w-4xl mx-auto px-5">

    {/* CONTENT */}
    <div className="text-center">

      <h2 className="text-xl md:text-2xl lg:text-[28px] font-bold tracking-tight text-primary mb-5">
        Aduri Group
      </h2>

      <p className="text-slate-600 text-sm leading-relaxed mb-10 max-w-3xl mx-auto">
        With a strong presence in the real estate sector, Aduri Group is committed
        to developing legally secure, thoughtfully planned, and future-ready
        residential projects across Telangana. Our focus is on delivering DTCP /
        RERA approved layouts, clear titles, and infrastructure-driven
        developments that offer long-term value to both investors and
        homeowners.
        <br /><br />
        Driven by transparency, quality execution, and customer trust, Aduri
        Group has consistently delivered projects in high-growth
        corridors—ensuring every investment is safe, sustainable, and rewarding.
        Our developments are designed to balance modern living, connectivity,
        and appreciation potential.
      </p>

      {/* STATS */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12 max-w-3xl mx-auto">
        <div>
          <h4 className="text-xl font-semibold text-primary">23+</h4>
          <p className="text-xs text-slate-500">Years of Experience</p>
        </div>

        <div>
          <h4 className="text-xl font-semibold text-primary">50+</h4>
          <p className="text-xs text-slate-500">Completed Projects</p>
        </div>

        <div>
          <h4 className="text-xl font-semibold text-primary">20+</h4>
          <p className="text-xs text-slate-500">OnGoing Projects</p>
        </div>

        <div>
          <h4 className="text-xl font-semibold text-primary">Large-Scale</h4>
          <p className="text-xs text-slate-500">
            Plotted & Township Developments
          </p>
        </div>

        <div>
          <h4 className="text-xl font-semibold text-primary">50000+</h4>
          <p className="text-xs text-slate-500">Associates</p>
        </div>
      </div>

      {/* CTA */}
      <button 
      onClick={() => navigate("/#premium-projects")}
      className="bg-primary text-white px-8 py-3 rounded-md text-sm font-medium hover:bg-primaryDark transition">
        View Our Properties
      </button>

    </div>
  </div>
</section>

{/* ================= FOUNDER’S NOTE ================= */}
<section className="pt-10 pb-10 bg-slate-50">
  <div className="max-w-4xl mx-auto px-5">

    <div className="text-center">

      <h2 className="text-xl md:text-2xl lg:text-[28px] font-bold tracking-tight text-primary mb-6">
        Founder’s Note
      </h2>

      <div className="text-slate-600 text-sm leading-relaxed space-y-6 max-w-3xl mx-auto">

        <p>
          <span className="font-medium text-slate-700">
            Dear Valued Customers,
          </span>
        </p>

        <p>
          At Aduri Group, our journey is built on a simple belief — real estate
          should be transparent, legally secure, and valuable for generations.
          We understand that purchasing land is one of the most important
          decisions in a person’s life, and we take that responsibility
          seriously.
        </p>

        <p>
          From project selection to execution, our focus remains on
          DTCP/RERA compliance, clear titles, strategic locations, and
          future-ready infrastructure. Every development we create is
          thoughtfully planned to deliver not just plots, but long-term peace
          of mind and sustainable growth.
        </p>

        <p>
          As we move forward, our commitment is to continue building trusted
          communities, strengthen customer relationships, and contribute
          meaningfully to the regions we develop. We are grateful for the trust
          our customers place in us and look forward to growing together.
        </p>

      </div>

    </div>
  </div>
</section>

      {/* ================= CTA ================= */}
<section className="pt-10 pb-10 bg-white">
  <div className="max-w-6xl mx-auto px-6">

    {/* Blue CTA Box */}
    <div className="bg-[#d9ecf4] rounded-2xl px-8 lg:px-12 py-10 flex flex-col lg:flex-row items-center justify-between gap-6">

      {/* LEFT CONTENT */}
      <div className="max-w-xl text-center lg:text-left">
        <h3 className="text-2xl lg:text-3xl font-bold text-primary mb-4">
          Interested in Learning More?
        </h3>

        <p className="text-slate-700 text-sm leading-relaxed mb-6">
          Fill out our inquiry form and our sales representative will get in
          touch with you to provide detailed information and schedule a site
          visit.
        </p>

        <button 
        onClick={() => navigate("/contact")}
        className="bg-primary text-white px-7 py-3 rounded-md text-sm font-medium hover:bg-primaryDark transition">
          Contact Us Now
        </button>
      </div>

      {/* RIGHT IMAGE */}
      <div className="flex-shrink-0 lg:-translate-x-8">
        <img
          src={ctaImg}
          alt="Contact Agent"
          className="w-64 h-64 rounded-full object-cover shadow-md"
        />
      </div>

    </div>
  </div>
</section>

    </div>
  );
};

export default About;
